export enum WREX_EMBEDDED_MAP {
    /**
     * @value Map
     * @description The label of the embedded map insertion button displayed in the editor's toolbar.
     */
    BUTTON_LABEL = 'WREX_EMBEDDED_MAP.BUTTON_LABEL',
}
